import React from "react";
import styles from "./FloorCardList.module.scss";

const FloorCardListSkeleton = () => {
	// 10 items fill the 350px tall card much more effectively.
	const fakeData = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
	return fakeData.map((x) => {
		return (
			<div
				className={`df aic m-b-10 ${styles.line} ${styles.noShadow}`}
				key={x}
				style={{ width: "100%", height: "38px", minHeight: "38px", display: "flex", alignItems: "center" }}
			>
				{/* Left side: checkbox and room for label (Explicit 56% width). */}
				<div
					className={`df aic fs15 fw500 ${styles.sec} ${styles.left}`}
					style={{ cursor: "default", paddingLeft: "12px", width: "56%", boxSizing: "border-box" }}
				>
					<div
						className="skeleton"
						style={{ width: "20px", height: "20px", borderRadius: "4px", marginRight: "12px", flexShrink: 0 }}
					/>
					<div
						className="skeleton"
						style={{ width: "75%", height: "12px", borderRadius: "4px" }}
					/>
				</div>

				{/* Right side: ColorBox placeholder and count (Explicit 44% width). */}
				<div
					className={`df aic ${styles.sec}`}
					style={{ cursor: "default", paddingLeft: "24px", gap: "10px", width: "44%", display: "flex", alignItems: "center", boxSizing: "border-box" }}
				>
					{/* Neutral ColorBox placeholder. */}
					<div
						className="skeleton"
						style={{ width: "10px", height: "22px", borderRadius: "3px", opacity: 0.35 }}
					/>
					{/* Total count placeholder (Bold/Primary). */}
					<div
						className="skeleton"
						style={{ width: "42px", height: "18px", borderRadius: "4px" }}
					/>
					{/* Percentage placeholder (Secondary). */}
					<div
						className="skeleton"
						style={{ width: "34px", height: "10px", borderRadius: "3px", opacity: 0.4 }}
					/>
				</div>
			</div>
		);
	});
};

export default FloorCardListSkeleton;
